import { AppRecordV2, IPermissionItem } from "@lhd/types";

type CompanyPolicyRecord = Pick<AppRecordV2, "policy_permissions">;

export const buildCompanyPolicyEditPermission = (
  data: CompanyPolicyRecord | null | undefined,
  pagePermission: IPermissionItem | undefined,
): IPermissionItem => ({
  view: data?.policy_permissions?.record_read,
  edit: data?.policy_permissions?.record_edit,
  delete: data?.policy_permissions?.record_delete,
  create: data?.policy_permissions?.record_delete && pagePermission?.create,
});
